<button class="split-button px-2.5">
    {{ text }}
</button>

<button #trigger class="split-button trigger" (click)="toggleMenu(trigger, menuTemplate); $event.stopPropagation();">
    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.234315 0.744078C0.546734 0.418641 1.05327 0.418641 1.36569 0.744078L4 3.48815L6.63432 0.744078C6.94673 0.418641 7.45327 0.418641 7.76569 0.744078C8.0781 1.06951 8.0781 1.59715 7.76569 1.92259L4.56569 5.25592C4.25327 5.58136 3.74673 5.58136 3.43431 5.25592L0.234315 1.92259C-0.0781049 1.59715 -0.0781049 1.06951 0.234315 0.744078Z" fill="currentColor"/>
    </svg>
</button>

<ng-template #menuTemplate>
    <div class="split-button-menu">
        <ng-content select="button" />
    </div>
</ng-template>